const beneficios = [
  { icon: 'ri-bar-chart-box-line', text: 'o comportamento se torna mais previsível' },
  { icon: 'ri-shield-line', text: 'muitas crises deixam de escalar' },
  { icon: 'ri-sun-line', text: 'o ambiente fica mais tranquilo' },
  { icon: 'ri-user-heart-line', text: 'o cuidador se sente mais seguro' }
];

export default function Beneficios() {
  return (
    <section className="py-12 sm:py-20 bg-gradient-to-b from-teal-50/30 to-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">

          {/* Coluna Esquerda - Texto + Cards */}
          <div className="space-y-7">
            <div className="space-y-3">
              <p className="text-xs sm:text-sm font-semibold tracking-widest text-teal-600 uppercase">
                Benefícios
              </p>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 leading-tight">
                Quando o cuidador aprende a identificar sinais e aplicar essas estratégias:
              </h2>
              <div className="w-12 h-1 bg-teal-500 rounded-full"></div>
            </div>

            <div className="grid gap-3">
              {beneficios.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 bg-white border border-teal-100 rounded-xl px-5 py-4 hover:border-teal-300 transition-colors duration-200"
                >
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-teal-600 rounded-lg">
                    <i className={`${item.icon} text-white text-lg`}></i>
                  </div>
                  <p className="text-gray-800 text-sm sm:text-base font-medium leading-snug">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Coluna Direita - Foto */}
          <div className="relative mt-6 lg:mt-0">
            <div className="relative w-full h-[280px] sm:h-[380px] lg:h-[520px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_af36280e2b9cc76256f67b665ddc9d52_057ab6ef.jpg"
                alt="Filha de 55 anos abraçando mãe idosa com carinho"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
